import { render, staticRenderFns } from "./editSurcharge.vue?vue&type=template&id=5be4e60c&scoped=true&"
import script from "./editSurcharge.vue?vue&type=script&lang=js&"
export * from "./editSurcharge.vue?vue&type=script&lang=js&"
import style0 from "./editSurcharge.vue?vue&type=style&index=0&id=5be4e60c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be4e60c",
  null
  
)

export default component.exports